import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f7ee995"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "isloading",
  "element-loading-text": "Loading...",
  "element-loading-background": "rgba(192, 192, 192, 0.5)"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, null, 512)), [
    [_directive_loading, _ctx.store.state.overLoading]
  ])
}